import React, { memo } from 'react'
import { Fab } from '@mui/material'

const CustomFab = ({ children, sx, ...restProps }) => {
  return (
    <Fab
      sx={{ ...sx, cursor: 'auto' }}
      {...restProps}
      disableRipple
      disableFocusRipple
    >
      {children}
    </Fab>
  )
}

export default memo(CustomFab)
